import { render, staticRenderFns } from "./OutOfDateBanner.vue?vue&type=template&id=74830a06&scoped=true"
import script from "./OutOfDateBanner.vue?vue&type=script&lang=js"
export * from "./OutOfDateBanner.vue?vue&type=script&lang=js"
import style0 from "./OutOfDateBanner.vue?vue&type=style&index=0&id=74830a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74830a06",
  null
  
)

export default component.exports